import { API_URL } from "../../../../../../constants";
import * as httpNetworking from "../../../../../../httpNetworking";

const VERSION = 0;

type GetLicenseDetailsResponse = {
    featureIds: string[];
};

export async function getLicenseKeySelectedFeatures(
    appId: string,
    data: {
        deploymentId: string;
    }
): Promise<GetLicenseDetailsResponse> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 60000,
        params: data
    };

    const url = API_URL + "/saas/multi-tenancy/connection-uri-domain/" + appId + "/license";

    const response = await httpNetworking.simpleGETRequest(url, options, VERSION);

    return response.data as GetLicenseDetailsResponse;
}
